<template>
  <div>
    <p>
      {{ i18n.t('/ExchangeCar/ModalManualCalculateBpm/Intro') }}
    </p>
    <form class="form-grid" @submit.prevent="submit">
      <app-fieldset :title="i18n.t('/ExchangeCar/ModalManualCalculateBpm/ModalTitle')">
        <div>
          <price-input
            id="tradeInValue"
            v-model="tradeInValue"
            name="tradeInValue"
            :title="i18n.t('/ExchangeCar/TradeInValue')"
          />
        </div>

        <div>
          <price-input
            id="originalBpmValue"
            v-model="originalBpmValue"
            name="originalBpmValue"
            :title="i18n.t('/ExchangeCar/ModalManualCalculateBpm/OriginalBpmValue')"
          />
        </div>

        <div>
          <date-picker
            id="admissionDate"
            :min-date="minAdmissionDate"
            :date="admissionDate"
            :title="i18n.t('/ExchangeCar/ModalManualCalculateBpm/DateFirstOnLicenseplate')"
            @change-date="changeAdmissionDate"
          />
        </div>
      </app-fieldset>

      <app-button
        data-qa="manual-bpm-calculation-save-button"
        type="submit"
        button-type="cta"
        class="submit-button"
        >{{ i18n.t('/Common/Save') }}</app-button
      >
    </form>
  </div>
</template>

<script>
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import PriceInput from '@/components/generic/presentational/atoms/priceInput/PriceInput.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import DatePicker from '@/components/generic/presentational/atoms/datePicker/DatePicker.vue'
import moment from 'moment'

export default {
  components: {
    AppButton,
    AppFieldset,
    PriceInput,
    DatePicker,
  },
  emits: ['onBpmCalculation'],
  data() {
    return {
      originalBpmValue: 0,
      monthsOnLicensePlate: 0,
      depreciationPercentageBpm: 0,
      residualBpmPercentage: 0,
      residualBpmValue: 0,
      tradeInValueExclBtwBpm: 0,
      tradeInValue: 0,
      vatValue: 0,
      admissionDate: moment(),
      minAdmissionDate: moment('1900-01-01', 'YYYY-MM-DD'),
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    submit() {
      this.$emit('onBpmCalculation', {
        originalBpmValue: this.originalBpmValue,
        tradeInValue: this.tradeInValue,
        admissionDate: this.admissionDate,
      })
    },
    changeAdmissionDate(value) {
      this.admissionDate = value
    },
  },
}
</script>

<style lang="scss" scoped>
.form-item {
  display: inline-block;
}
</style>
